export const normalize = (value, max, min = 0) => (value - min) / (max - min)
